import React from "react";
import VideoAndAssistance from "./VideoAndAssistance";

const Soccer10Rules = () => {
  return (
    <div>
      <VideoAndAssistance videoId="JAB5E-uPE4Y" />

      <h2>Key Soccer 10 Information</h2>
      <p>Soccer 10 is just like Soccer 6, but there are 10 matches (M1 through M10) instead of six. The other differences are:</p>
      <ul>
        <li>Only R2 to play</li>
        <li>80% of pool = all 10 matches correct</li>
        <li>20% of pool = any nine matches correct</li>
      </ul>
      <p>The record payout for Soccer 10 is R2,106,857.</p>
      <p>
        As with Soccer 6, you can play a single or multiple entry. With a single entry, you select ONE option or choice for each match and the bet costs R2.
      </p>
      <p>
        With a multiple entry, you can choose more than one option in one or more matches. The cost is R2 per combination. To calculate the number of
        combinations, multiply out the total number of options or choices for each match. Then take that total and multiply it by 2 to calculate the cost of the
        bet.
      </p>
      <h2>Examples</h2>
      <div className="panel">
        You choose all three options in M1 (Match 1), two options in M2 and one in each of M3, M4, M5, M6, M7, M8, M9 and M10. That's 3x2x1x1x1x1x1x1x1x1= 6
        combinations x R2 = R12.
      </div>
      <div className="panel">You choose two options in each of the first 8 matches and one in M9 and M10. That's 2x2x2x2x2x2x2x2x1x1 =256 x 2 = R512</div>
      <div className="panel">
        80% of the pool shall be allocated for bets with all 10 matches correct and the other 20% of pool for entries with any nine of the 10 matches correct.
        If 80% portion of pool not won, it shall be carried forward to the 80% portion of a selected Soccer 10 pool. If nobody forecasts any nine matches
        correctly, this 20% portion of the pool shall be carried forward to the 80% portion of a selected Soccer 10 pool.
      </div>
    </div>
  );
};

export default Soccer10Rules;
